import type {AddButtonProps, EmptyStateProps} from 'shells/card/card-widget/card-widget';
import {PeopleRegularIcon} from 'shells/icon/svg/people-regular-icon';

import {PreferenceCenterLinkCopy} from '../../../email-marketing/audiences/preference-center-link-copy';

export function getEmptyStateProps(
    isEmpty: boolean,
    isUnsubscribed: boolean,
    preferenceCenterLink: string | null | undefined,
    canAccessMarketing: boolean
): EmptyStateProps {
    if (!canAccessMarketing) {
        return {
            isEmpty: true,
            text: 'You must have a Nutshell Marketing license\nto view audiences',
            icon: PeopleRegularIcon,
            iconSize: 22,
        };
    } else if (isUnsubscribed) {
        return {
            isEmpty: true,
            text: 'This person has unsubscribed from all outreach and can’t be added to audiences.\n\nTo resubscribe, they must update their own preferences.',
            icon: PeopleRegularIcon,
            iconSize: 22,
            cta: preferenceCenterLink ? (
                <PreferenceCenterLinkCopy link={preferenceCenterLink} />
            ) : undefined,
        };
    }

    return {
        isEmpty: isEmpty,
        text: 'No audiences assigned',
        icon: PeopleRegularIcon,
        iconSize: 22,
    };
}

export function getAddButtonProps(
    onClick: () => void,
    getButtonRef: (ref: HTMLButtonElement | null | undefined) => void,
    isDisabled: boolean,
    shouldShowButton: boolean
): AddButtonProps | undefined {
    if (!shouldShowButton) {
        return undefined;
    }

    return {
        variant: 'singular',
        label: '+ Add to audience',
        onClick: onClick,
        getButtonRef: getButtonRef,
        isDisabled: isDisabled,
    };
}
